export default function fetchData({
  url,
  method = "GET",
  host = process.env.REACT_APP_API_HOST,
}) {
  return fetch(`${host}${url}`, {
    method,
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const jsonResponses = await response.json();
    if (response.ok) return jsonResponses;

    throw new Error(JSON.stringify(jsonResponses));
  });
}
